// extracted by mini-css-extract-plugin
export default {"mapTemplateContainer":"ZFRX5XqBvGWL6v01ERpu"};